/**
 * @generated SignedSource<<34d31a79fa7b5bbd61d791509eae8319>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutUIActionsTransactionSetup_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIReducer_buyer">;
  readonly " $fragmentType": "checkoutUIActionsTransactionSetup_buyer";
};
export type checkoutUIActionsTransactionSetup_buyer$key = {
  readonly " $data"?: checkoutUIActionsTransactionSetup_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIActionsTransactionSetup_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIActionsTransactionSetup_buyer"
};

(node as any).hash = "a9c5ffd23aed64ab8065c744635efcc5";

export default node;
